import makeParameters from "./make_parameters";

export default makeParameters();
